import React from "react";

import { PartnerID } from "modules/parties/types/Partner";
import { Box, Typography, Grid } from "@mui/material";

import { useDispatch, shallowEqual } from "react-redux";
import { useSelector } from "redux/reducer";
import { IconType } from "components/Icons";

import {
  getPartnerRoute,
  ROUTE_TEMPLATE,
  getRoute,
} from "modules/navigation/routes";
import { go } from "modules/navigation/helpers/navigator";
import AnalysisOffering from "../AnalysisOffering";

type AnalysisProps = {
  partnerId: PartnerID | undefined;
};

const Analysis: React.FC<AnalysisProps> = ({ partnerId }) => {
  const dispatch = useDispatch();
  const { partner } = useSelector(
    (state) => ({
      partner: state.partner,
    }),
    shallowEqual,
  );

  const showAnalysis = partner ? Boolean(partner?.data?.medicaid) : true;

  const handleNavigateToPlanTailoring = () => {
    partnerId && showAnalysis
      ? go(
          dispatch,
          getPartnerRoute(partnerId, ROUTE_TEMPLATE.PARTNER_MEDICAID_LEAD_NEW),
        )
      : go(dispatch, getRoute(ROUTE_TEMPLATE.MY_PARTNERS));
  };

  if (!showAnalysis) return null;

  return (
    <Box>
      <Typography variant="h3">Analysis</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <AnalysisOffering
            title="Medicaid Analysis"
            description="See how much of your home and savings you can protect from long term care costs."
            price="Free Analysis"
            handleSelect={handleNavigateToPlanTailoring}
            icon={IconType.ADD_MEDICAID}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Analysis;
